// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { palm as _palm } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the palm chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 11297108109
 * Chain Name: Palm
 * Default Block Explorer: https://palm.chainlens.com
 * Default RPC URL: https://palm-mainnet.public.blastapi.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { palm } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: palm,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const palm = createCommon({
	..._palm,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
